/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  CreateProductPageComponentMutationRequest,
  CreateProductPageComponentMutationResponse,
} from "../types/CreateProductPageComponent.ts"

export const createProductPageComponentMutationKey = () =>
  [{ url: "/v1/organization-settings/product-page-components" }] as const

export type CreateProductPageComponentMutationKey = ReturnType<
  typeof createProductPageComponentMutationKey
>

/**
 * @summary Create product page component
 * {@link /v1/organization-settings/product-page-components}
 */
export async function createProductPageComponent(
  data: CreateProductPageComponentMutationRequest,
  config: Partial<RequestConfig<CreateProductPageComponentMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateProductPageComponentMutationResponse,
    ResponseErrorConfig<Error>,
    CreateProductPageComponentMutationRequest
  >({
    method: "POST",
    url: `/v1/organization-settings/product-page-components`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function createProductPageComponentMutationOptions(
  config: Partial<RequestConfig<CreateProductPageComponentMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const mutationKey = createProductPageComponentMutationKey()
  return mutationOptions<
    ResponseConfig<CreateProductPageComponentMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateProductPageComponentMutationRequest },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return createProductPageComponent(data, config)
    },
  })
}

/**
 * @summary Create product page component
 * {@link /v1/organization-settings/product-page-components}
 */
export function useCreateProductPageComponent<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateProductPageComponentMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: CreateProductPageComponentMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<CreateProductPageComponentMutationRequest>
    > & { client?: typeof fetch }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? createProductPageComponentMutationKey()

  const baseOptions = createProductPageComponentMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<CreateProductPageComponentMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateProductPageComponentMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<CreateProductPageComponentMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateProductPageComponentMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<CreateProductPageComponentMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateProductPageComponentMutationRequest },
    TContext
  >
}
